import { FilterdColumns } from '@oscar/table';
import {
  STATUS_FILTER_COLUMN,
  STATUS_FILTER_INSULATION,
  STATUS_FILTER_REQUESTOR,
  STATUS_FILTER_CONTRACTOR,
  STATUS_FILTER_PAINTING,
} from 'common/constants';
import { Roles, useAuth } from 'features/auth';
import React from 'react';
import './style.scss';

const { OptionGroup } = FilterdColumns;

function FilterStatusColumnTableHome(props: any) {
  const [auth] = useAuth();
  const role = auth?.getUserRoles();
  let statusFilterColumn;

  if (role[0] === 'ADMIN') {
    statusFilterColumn = STATUS_FILTER_COLUMN;
  } else if (role[0] === 'OSCAR') {
    statusFilterColumn = STATUS_FILTER_REQUESTOR;
  } else if (role[0] === 'CONTRACTOR') {
    statusFilterColumn = STATUS_FILTER_CONTRACTOR;
  } else if (role[0] === 'PAINTING') {
    statusFilterColumn = STATUS_FILTER_PAINTING;
  } else {
    statusFilterColumn = STATUS_FILTER_INSULATION;
  }
  return (
    <OptionGroup
      {...props}
      data={Object.values(statusFilterColumn).map(item => ({
        value: item.VALUE,
        label: item.TEXT,
      }))}
    />
  );
}

export default FilterStatusColumnTableHome;
